import React from "react"
import ProductScrollableList from "./ProductScrollableList"
import useT from "../hooks/useT"
import useAsync from "../hooks/useAsync"
import useSiteLanguage, { useCurrency } from "../hooks/useSiteLanguage"
import { useRecentlyViewed } from "../store/recentlyViewed"
import { ListProducts, LIST_FIELDS } from "../api"

/**
 * "Recently viewed products": the products this browser looked at, laid out
 * as the "Latest" row is. Nothing while there is nothing to show. `except`
 * leaves out the product of the page the row is on.
 */
export default function RecentlyViewed({ except, className = "" }) {
  const t = useT()
  const language = useSiteLanguage()
  const currency = useCurrency()
  const pids = useRecentlyViewed({ except })
  const key = pids.join(",")
  const { result } = useAsync(
    () => ListProducts({ page: 0, pids, items_per_page: pids.length, language, currency, owned_only: false, fields: LIST_FIELDS }),
    [key, language, currency],
    { enabled: pids.length > 0 }
  )
  const products = result?.list || []
  if (!pids.length || !products.length) return null
  return (
    <div className={className} data-testid="recently-viewed">
      <ProductScrollableList placement="recently_viewed" title={t`Recently viewed products`} products={products} moreProductsBtn={false} />
    </div>
  )
}
